import { Component, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import Amplify from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';
import { MatSnackBar } from '@angular/material/snack-bar';
import { localImages, stringsList } from '../dashboard/constants/app-config';
import { LoginModel } from './login.model';
import { ClientService } from '../dashboard/preview/invoices/services/client.service';
import { View } from '../dashboard/preview/models/view.model';
import { log } from 'console';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  localImages = localImages;
  stringsList = stringsList;
  hide: boolean = false;
  loginData: LoginModel = {
    email: '',
    password: '',
    confirmPassword: '',
    opt: '',
  };
  otp: string = '';
  view: View = {
    isLogin: true,
    isForgotPassword: false,
    isVerify: false,
    isNewPassword: false,
    isSuccess: false,
  };
  tempPass: string = 'Pass123!';
  formGroup!: UntypedFormGroup;
  titleAlert: string = 'This field is required';
  post: string = '';
  isLoading: boolean = false;
  isLoadingDots: boolean = false;
  changingPassword: boolean = false;
  errorMessage: string | null = null;
  showConfirmPassword: boolean = false;
  showPassword: boolean = false;
  isWrongCode: boolean = false;
  isSubmitting: boolean = false;
  isUsernameReadOnly:boolean = true
  logoUrl: string = '/assets/logo 3.svg'; // Default fallback logo
  account_validation_messages = {
    username: [
      { type: 'required', message: 'Username is required' },
      {
        type: 'minlength',
        message: 'Username must be at least 4 characters long',
      },
      {
        type: 'maxlength',
        message: 'Username cannot be more than 25 characters long',
      },
      {
        type: 'validUsername',
        message: 'Your username has already been taken',
      },
    ],
    password: [
      { type: 'required', message: 'Password is required' },
      {
        type: 'pattern',
        message:
          'Password needs to be at least eight characters, one uppercase letter and one number',
      },
    ],
    confirmPassword: [
      { type: 'required', message: 'Password is required' },
      {
        type: 'pattern',
        message:
          'Password needs to be at least eight characters, one uppercase letter and one number',
      },
    ],
    opt: [{ type: 'required', message: 'OPT is required' }],
  };
  constructor(
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private snackBar: MatSnackBar,
    private clinetService: ClientService
  ) {
    // this.formGroup = this.formBuilder.group({
    //   name: [null, Validators.required],
    //   password: [null, [Validators.required]],
    // });
  }

  ngOnInit(): void {
    this.redirectUser();
    this.createForm();
    
    // Get logoUrl from localStorage for display
    const userInfo = localStorage.getItem('userInfo');
    if (userInfo) {
      try {
        const user = JSON.parse(userInfo);
        if (user.logoUrl) {
          this.logoUrl = user.logoUrl;
        }
      } catch (error) {
        console.error('Error parsing userInfo from localStorage:', error);
      }
    }
  }

  changeView(
    viewName:
      | 'isLogin'
      | 'isForgotPassword'
      | 'isVerify'
      | 'isNewPassword'
      | 'isSuccess'
  ): void {
    this.errorMessage = null;
    this.view.isForgotPassword = false;
    this.view.isVerify = false;
    this.view.isLogin = false;
    this.view.isSuccess = false;
    this.view.isNewPassword = false;
    this.view[viewName] = true;
  }

  verifyCode() {
    Auth.forgotPasswordSubmit(this.loginData.email, this.otp, this.tempPass)
      .then(async (data) => {
        this.changeView('isNewPassword');
        await Auth.signIn(this.loginData.email, this.tempPass);
      })
      .catch((err) => {
        if (
          err.message ===
          'Invalid verification code provided, please try again.'
        ) {
          this.errorMessage = 'Wrong verification code.';
        } else if (
          err.message === 'Attempt limit exceeded, please try after some time.'
        ) {
          this.errorMessage = 'Attempt limit exceeded, try later';
        }
      });
  }

  sendVerificationCode(): void {
    Auth.forgotPassword(this.loginData.email)
      .then(() => {
        this.snackBar.open('SUCCESS, code sent to your email.', '', {
          duration: 5000,
          panelClass: ['white-snackbar'],
        });
        this.errorMessage = null;
        this.changeView('isVerify');
      })
      .catch((err) => {
        this.errorMessage = "Hmm, we don't recognise that username.";
      });
  }

  createForm() {
    this.formGroup = this.formBuilder.group({
      name: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(25),
        ]),
      ],

      password: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern(
            '^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&])([a-zA-Z0-9@$!%*?&]{8,})$'
          ),
        ]),
      ],
    });
  }

  onOtpChange($event: string) {
    this.errorMessage = '';
    this.otp = $event;
  }

  redirectUser() {
    Auth.currentAuthenticatedUser({
      bypassCache: false,
    })
      .then(() => {
        this.router.navigate(['']);
      })
      .catch(() => {
        this.router.navigate(['/login']);
      });
  }

  async signIn(post: LoginModel): Promise<void> {
    this.isLoadingDots = true;
    try {
      let user = await Auth.signIn(post.email, post.password);
      let userInfo = await Auth.currentUserInfo();

      if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        await Auth.completeNewPassword(user, post.password);
        user = await Auth.signIn(post.email, post.password);
        userInfo = await Auth.currentUserInfo();
      }
      const isUserExist: any = await this.clinetService.GetClient(
        userInfo.attributes.sub
      );
      localStorage.setItem(
        'userInfo',
        JSON.stringify({ 
          phone: isUserExist.phone, 
          email: isUserExist.email, 
          isVatIncluded: isUserExist.isVatIncluded,
          logoUrl: isUserExist.logoUrl 
        })
      );
      if (!isUserExist) {
        await Auth.signOut();
        throw new Error("User doesn't exist in database");
      }

      if (isUserExist.status === 'DISABLED') {
        await Auth.signOut();
        throw new Error('Your profile is disabled!');
      }

      localStorage.setItem('userID', userInfo.attributes.sub);
      if (
        !user.signInUserSession.idToken.payload['cognito:groups'].includes(
          'CLIENT'
        )
      ) {
        await Auth.signOut();
        throw new Error('Wrong informations provided');
      }
      const tokens = user.signInUserSession;
      if (tokens != null) {
        this.router.navigate(['/overview']);
        this.isLoadingDots = false;
      }
      Auth.currentAuthenticatedUser({
        bypassCache: false,
      }).catch((err) => console.log(err));
    } catch (error: any) {
      console.log('error', error);
      
      this.isLoadingDots = false;
      if (error.code == 'UserNotFoundException') {
        this.titleAlert = error.message;
        this.formGroup.controls['name'].setErrors({ incorrect: true });
      }
      if (error.code == 'NotAuthorizedException') {
        this.titleAlert = error.message;
        this.formGroup.controls['name'].setErrors({ incorrect: true });
        this.formGroup.controls['password'].setErrors({ incorrect: true });
      }
      if (error.code == 'UserNotConfirmedException') {
        this.titleAlert = 'Account not confirmed!';
        Auth.resendSignUp(this.loginData.email).then((res) => {
          this.router.navigate(['/signup'], {
            queryParams: { step: 1, username: this.loginData?.email },
          });
          this.snackBar.open(
            'Please, confirm your account before attempting to log in!',
            '',
            {
              duration: 7000,
              panelClass: ['white-snackbar'],
            }
          );
          return;
        });
      }
      if (error.message == 'User does not exist.' || error.message == 'Incorrect username or password.') {
        this.errorMessage = 'Invalid username and password combination.';
      } else {
        Auth.signOut();
        this.errorMessage = 'Invalid username and password combination.';
      }
    }
  }

  sendLoginLink(loginData: LoginModel) {
    Auth.forgotPassword(loginData.email)
      .then((res) => {
        this.errorMessage = null;
        this.changeView('isNewPassword');
      })
      .catch((err) => {
        this.errorMessage = 'Wrong informations provided, please check again.';
        this.timeOutErrorMessage();
      });
  }

  async changePassword(loginData: any) {
    if (loginData.password !== loginData.confirmPassword) {
      this.errorMessage = 'Passwords do not match';
      return;
    }

    this.changingPassword = true;
    let userInfo = await Auth.currentAuthenticatedUser();
    Auth.changePassword(userInfo, this.tempPass, loginData.confirmPassword)
      .then(() => {
        this.errorMessage = null;
        this.changingPassword = false;
        Auth.signOut();
       this.view.isNewPassword = false
       this.view.isSuccess = true
      })
      .catch((err) => {
        console.log('err', err);
        if (
          err.message == 'Invalid verification code provided, please try again.'
        ) {
          this.errorMessage = 'Invalid verification code provided.';
          this.isWrongCode = true;
          this.changingPassword = false;
          return;
        }
        this.errorMessage = 'Wrong informations provided, please check again.';
        this.timeOutErrorMessage();
        this.changingPassword = false;
      });
  }

  timeOutErrorMessage() {
    setTimeout(() => {
      this.errorMessage = null;
    }, 3000);
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  goBackToEnteringCodeScreen() {
    this.isWrongCode = false;
    this.changeView('isVerify');
    this.errorMessage = '';
  }

  redirectToSignUp() {
    this.router.navigate(['/signup']);
  }

  setUsernameToReadOnlyFalse(){
    this.isUsernameReadOnly = false;
  }

  redirectToLogin(){
    this.router.navigate(['/login']);
    this.view.isSuccess = false
    this.view.isLogin = true
  }
}
